import { render, staticRenderFns } from "./lolth-pagination-grid.vue?vue&type=template&id=3d45c1ee&"
import script from "./lolth-pagination-grid.vue?vue&type=script&lang=ts&"
export * from "./lolth-pagination-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./lolth-pagination-grid.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports